import { Collection, User } from "@/types";
import { api } from "@/utils/api";
import { camelize, Camelize } from "@/utils/api-helpers";
import { useSuspensePaginatedQuery, UseSuspensePaginatedQueryOptions } from "@/utils/query";

export const useUsers = (
  projectId: string,
  options?: Omit<UseSuspensePaginatedQueryOptions<User>, "queryKey" | "url">,
) => {
  return useSuspensePaginatedQuery<User>({
    queryKey: ["projects", projectId, "users"],
    url: `/projects/${projectId}/users`,
    ...options
  });
};

export async function searchUsers(
  projectId: string,
  query: string,
): Promise<Camelize<User>[]> {
  const params = query ? `?query=${encodeURIComponent(query)}&limit=25` : "?limit=25";
  const response = await api.get<Collection<User>>(`/projects/${projectId}/users${params}`);
  return camelize(response.data).items;
}
